export const randomIntFromInterval = function (min = 0, max = 360) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export const arrayRotateOne = function (arr, reverse) {
  reverse ? arr.unshift(arr.pop()) : arr.push(arr.shift())
  return arr
}